import createReducer from '../../../../helpers/createReducer';
import { fetchUserRoleOptions } from '../../../sagas/routines';

const initialState = {
  all: [],
  meta: {},
  fetching: false,
  fetched: false
};

const fetchUserRoleOptionsHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, fetching: true, fetched: false }),
  [routine.SUCCESS]: (state, { payload: { response } }) => ({
    ...state,
    all: response.items,
    meta: response.meta
  }),
  [routine.FULFILL]: state => ({
    ...state,
    fetching: false,
    fetched: true
  })
});

export default createReducer(initialState, {
  ...fetchUserRoleOptionsHandler(fetchUserRoleOptions)
});
